module.exports = __webpack_public_path__ + "img/prontotec.a87c429c.png";